import React from "react";
import PropTypes from "prop-types";

import map from "lodash/map";
import groupBy from "lodash/groupBy";
import findIndex from "lodash/findIndex";

// import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faTimesCircle,
    faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";

import dataAlerts from "./data/data-alerts.json";
import HeModal from "../HeModal";
import "./HeEPS.scss";

let alertsByGeo = {};
dataAlerts.forEach((alert) => {
    if (
        findIndex(
            Object.keys(alertsByGeo),
            (fips) => alert.fips.toString() === fips
        ) === -1
    ) {
        alertsByGeo[alert.fips] = [];
    }
    alertsByGeo[alert.fips].push(alert);
});

class HeEPS_geoList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false,
            modalIcon: "",
            modalTitle: "",
            modalContent: null,
            modalFooter: null,
        };
    }

    componentDidUpdate() {
        // scroll to the bottom of the list when a single geo is added
        if (
            this.previosListLength &&
            this.props.selectedGeos.length - this.previosListLength === 1
        ) {
            this.scrollToBottom();
        }
        this.previosListLength = this.props.selectedGeos.length;
    }

    render() {
        return (
            <div>
                {/* {this.renderHeader()} */}

                <div
                    // id="selected-geos-container"
                    className="HeEPS-GeoList-selectedGeos"
                >
                    {this.renderGeoContainer()}
                    <div
                        style={{ float: "left", clear: "both" }}
                        ref={(el) => {
                            this.bottomOfGeoContainer = el;
                        }}
                    />
                </div>
                <HeModal
                    headerFontAwesomeIcon={this.state.modalIcon}
                    isOpen={this.state.modalIsOpen}
                    content={this.state.modalContent}
                    headerText={this.state.modalTitle}
                    onCloseRequest={() => {
                        this.setState({ modalIsOpen: false });
                    }}
                />
            </div>
        );
    }
    scrollToBottom() {
        // commented out until the mechanics of this are better worked out for a scrolling page
        //this.bottomOfGeoContainer.scrollIntoView({ behavior: "smooth" });
    }

    renderGeoContainer() {
        let _this = this;
        if (this.props.selectedGeos.length === 0) {
            return null;
        }
        let geosByGroupLevel = groupBy(this.props.selectedGeos, "geoLevel");
        return map(Object.keys(geosByGroupLevel), function(geoLevel) {
            return (
                <div key={geoLevel}>
                    {/* <div className="HeEPS-GeoList-selectedGeoLevel">
                        {groupNameArray[geoLevel][1]}
                    </div> */}
                    {_this.renderGeoListNew(geosByGroupLevel[geoLevel])}
                </div>
            );
        });
    }
    renderGeoListNew(geoList) {
        let _this = this;
        return map(geoList, (geo) => {
            // geo = _this.addDataAlerts(geo, this.props.templateName);
            const alerts = this.getAlerts(geo.id);

            let allAlerts = [];
            if (alerts.length > 0) {
                alertsByGeo[geo.id].forEach((alert) =>
                    allAlerts.push(alert.message)
                );
            }
            if (geo.excludeAlert) {
                allAlerts.push(geo.excludeAlert);
            }

            return (
                <div
                    key={geo.id}
                    onMouseEnter={() => this.props.onMouseEnter(geo.id)}
                    onMouseLeave={() => this.props.onMouseLeave(geo.id)}
                    style={{ padding: "0 5px 0 10px" }}
                    className="HeEPS-pill"
                >
                    {/* {this.renderGeoGroup(geo)} */}
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "auto 24px",
                        }}
                    >
                        <div style={{ paddingRight: 4 }}>
                            {geo.label}
                            {alerts.length > 0 || geo.excludeAlert ? (
                                <FontAwesomeIcon
                                    icon={faExclamationTriangle}
                                    className="HeEPS-fa HeEPS-fa-alert"
                                    onClick={() => {
                                        this.showModal(
                                            <FontAwesomeIcon
                                                icon={faExclamationTriangle}
                                                style={{
                                                    color: "rgb(216,133,42)",
                                                }}
                                            />,
                                            geo.label,
                                            <ul>
                                                {allAlerts.map((alert) => {
                                                    return <li>{alert}</li>;
                                                })}
                                            </ul>,
                                            <button
                                                onClick={this.handleCloseModal}
                                            >
                                                Close
                                            </button>
                                        );
                                    }}
                                />
                            ) : null}
                        </div>

                        <FontAwesomeIcon
                            icon={faTimesCircle}
                            className="HeEPS-fa"
                            onClick={() => {
                                _this.props.removeGeo(geo.id);
                            }}
                        />
                    </div>
                </div>
            );
        });
    }

    getAlerts(fips) {
        let alerts = [];
        if (alertsByGeo.hasOwnProperty(fips)) {
            alertsByGeo[fips].forEach((alert) => {
                if (
                    alert.report === "" ||
                    this.props.templateName === alert.report
                ) {
                    alerts.push(alert.message);
                }
            });
        }
        return alerts;
    }

    showModal(icon, title, content, footer) {
        this.setState({
            modalIsOpen: true,
            modalIcon: icon,
            modalTitle: title,
            modalContent: content,
            modalFooter: footer,
        });
    }

    //     addDataAlerts(geo) {

    //         geo.displayDataAlert = false; // assume no data alert exists for this geo/report combination

    //         const alertsForGeo = this.props.dataAlerts.filter(alert=>alert.fips===geo.fips);
    //         if (alertsForGeo.length===0) return geo;

    //         let _this = this;
    //         var dataAlertText = "";

    //         alertsForGeo.forEach(alert=>{
    //             if (typeof alert.report === "undefined") {
    //                 dataAlertText = geo.name + ": " + alert.message;
    //                 if (alert.statewide === 1 && alert.st === 'AK') {
    //                     dataAlertText =  dataAlertText + geo.name + ": " + alert.message;
    //                 }
    //             }
    //             else {
    //                 var rptName = alert.report.replace("-", "").toLowerCase();
    //                 if (rptName === _this.props.templateName) {
    //                     dataAlertText =dataAlertText + geo.name + ": " + alert.message;
    //                     if (alert.statewide === "1") {
    //                         if (alert.st === "AK") {
    //                             dataAlertText = dataAlertText + geo.name + ": " + alert.message;
    //                         }
    //                     }
    //                 }
    //             }
    //         })

    //         // this.props.dataAlerts.forEach(function(d) {
    //         //     if (typeof d.report === "undefined") {
    //         //         d.report = "";
    //         //     }

    //         //     if (d.report === "") {
    //         //         // if this message is not associated only with a specific report
    //         //         if (+d.fips === geo.fips) {
    //         //             // if the user has selected this fips code
    //         //             dataAlertText = geo.name + ": " + d.message;
    //         //         } else if (alert.statewide === 1 && alert.st === 'AK') {
    //         //             // if the message is a statewide message
    //         //             if (d.st === geo.stateabbr) {
    //         //                 // if the fips code is in this state
    //         //                 dataAlertText =
    //         //                     dataAlertText + geo.name + ": " + d.message;
    //         //             } // end of test for fips code in this state
    //         //         }
    //         //     }
    //         //     else {
    //         //         // if this message is associate with a specific report
    //         //         var rptName = d.report.replace("-", "").toLowerCase();
    //         //         if (rptName === _this.props.templateName) {
    //         //             if (+d.fips === geo.fips) {
    //         //                 dataAlertText =
    //         //                     dataAlertText + geo.name + ": " + d.message;
    //         //             } else if (d.statewide === "1") {
    //         //                 if (d.st === geo.stateabbr) {
    //         //                     dataAlertText =
    //         //                         dataAlertText + geo.name + ": " + d.message;
    //         //                 }
    //         //             }
    //         //         }
    //         //     }
    //         // });
    //         geo.dataAlertText = dataAlertText;
    //         if (dataAlertText !== "") {
    //             geo.displayDataAlert = true;
    //         }
    //         return geo;
    //     }
}

HeEPS_geoList.propTypes = {
    selectedGeos: PropTypes.arrayOf(
        PropTypes.shape({
            fips: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            label: PropTypes.string,
            geoLevel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            excludeAlert: PropTypes.string,
        })
    ),

    /** Triggers the parent to update the selectedGeosList */
    clearGeos: PropTypes.func,
    /** Returns fips code so the list can be modified */
    removeGeo: PropTypes.func,

    templateName: PropTypes.string,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
};

HeEPS_geoList.defaultProps = {
    templateName: "WUI",
    onMouseEnter: () => {},
    onMouseLeave: () => {},
};

export default HeEPS_geoList;
